import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    isLayoutMobile: boolean;
  }>()
  .create(({ theme, isLayoutMobile }) => ({
    orgAutoComplete: {
      border: 0,
      maxWidth: 400,
      minWidth: 250,
      ...(isLayoutMobile && {
        '& .MuiInputBase-root': {
          borderRadius: 0
        },
        '& .MuiOutlinedInput-root': {
          minHeight: '4.35rem',
          paddingLeft: '0.75rem!important'
        },
        '& fieldset': {
          borderLeft: 0,
          borderRight: 0
        }
      }),
      ...(!isLayoutMobile && {
        width: '20vw'
      })
    },
    orgLabel: {
      backgroundColor: theme.vars.palette.secondary.light,
      borderRadius: theme.shape.borderRadius,
      color: theme.vars.palette.secondary.contrastText,
      fontWeight: 700
    }
  }));

export default useStyles;
